import script from "./ProductDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailPage.vue?vue&type=style&index=0&id=6e00c3c1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e00c3c1"]])

export default __exports__